import { render } from "./VocabularyBook.vue?vue&type=template&id=68d061fe&scoped=true"
import script from "./VocabularyBook.vue?vue&type=script&lang=js"
export * from "./VocabularyBook.vue?vue&type=script&lang=js"

import "./VocabularyBook.vue?vue&type=style&index=0&id=68d061fe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d061fe"]])

export default __exports__